<template>
  <div
    :class="className"
    :style="{ height: height, width: width }"
    ref="myBarChart"
  ></div>
</template>

<script>
import echarts from "echarts";
import resize from "./mixins/resize";
require("echarts/theme/macarons"); // echarts theme
export default {
  name: "BarChart",
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "350px"
    },
    autoResize: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      chart: null,
      barChartData: {
        gameNameList: [],
        androidTotal: [],
        iosTotal: []
      }
    };
  },
  mounted() {
    this.getGameCount();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    getGameCount() {
      this.axios.get("/game/getGameCount").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.barChartData = resp.data.data;
          this.initChart();
        }
      });
    },
    initChart() {
      this.chart = echarts.init(this.$refs.myBarChart, "macarons");
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          top: 10,
          data: ["安卓下载", "IOS点击"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true
        },
        xAxis: {
          type: "value",
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: "category",
          axisTick: {
            show: true
          },
          data: this.barChartData.gameNameList
        },
        series: [
          {
            name: "安卓下载",
            type: "bar",
            stack: "总量",
            label: {
              show: true,
              position: "insideRight"
            },
            itemStyle: {
              normal: {
                color: "#67c23a"
              }
            },
            data: this.barChartData.androidTotal
          },
          {
            name: "IOS点击",
            type: "bar",
            stack: "总量",
            label: {
              show: true,
              position: "insideRight"
            },
            itemStyle: {
              normal: {
                color: "#f56c6c"
              }
            },
            data: this.barChartData.iosTotal
          }
        ]
      });
    }
  }
};
</script>

<style scoped></style>
